import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import config from '../../../../core/config/config';
import BseRepository from '../../../repositories/BseRepository';
import BseDataRepository from '../../../../data/repositories/BseDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.PROCESS_FORM_BSE_REQUEST });
    const scholarshipsBseRepository: BseRepository = new BseDataRepository();

    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);

    XCheckpointManager.registerStart('BSE - Send request');
    const processBseResponse = yield call(
      scholarshipsBseRepository.processBse,
      action.idRequest,
      false
    );
    XCheckpointManager.registerEnd('BSE - Send request');

    if (!processBseResponse) {
      yield put({
        type: Types.PROCESS_FORM_BSE_FAILURE,
        error: 'No se pudo procesar'
      });
      return;
    }

    if (processBseResponse?.message === 'Error') {
      yield put({
        type: Types.PROCESS_FORM_BSE_FAILURE,
        error: processBseResponse?.message
      });
      yield put({
        type: 'TOGGLE_SNACKBAR_OPEN'
      });
      return;
    }

    yield put({
      type: Types.PROCESS_FORM_BSE_SUCCESS,
      data: processBseResponse
    });
  } catch (error) {
    yield put({
      type: Types.PROCESS_FORM_BSE_FAILURE,
      error:
        'Ocurrió un error al momento de procesar los datos del trámite solicitado.'
    });
  }
}
